module.exports = __webpack_public_path__ + "img/ic_add_special_num_sm.1625874e.svg";